<template>
<div class="basicMain">
  <h2>基本信息</h2>
  <basicInformation @toParent="getdata"  ></basicInformation>
  <h2>财务信息</h2>
  <financialInformation v-if="financialShow===true"></financialInformation>
</div>
</template>

<script>
import basicInformation from '@/pages/wpsp/base-information/basic-information.vue';
import financialInformation from '@/pages/wpsp/base-information/financial-information.vue';

export default {
  components: { basicInformation, financialInformation },
  name: 'basicMain',
  data() {
    return {
      financialShow: false,
    };
  },
  mounted() {
    sessionStorage.setItem('cis', JSON.stringify(this.$route.query.cis));
  },
  methods: {
    getdata(data) {
      console.log('11111', data);
      if (data.status) {
        this.financialShow = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.basicMain{
  padding: 0 20px;
  h2{
    font-size: 16px;
    color: #303133;
    margin: 16px 0 12px;
  }
}
</style>
